import React from 'react'
import PropTypes from 'prop-types'
import Loading, { LOADING_ICON_BLUE_DARK_BG_WHITE } from '../../Loading/index'

const GiftLoadingPropTypes = {
  visible: PropTypes.bool,
}

/**
 * @type {React.FC<PropTypes.InferProps<GiftLoadingPropTypes>>}
 * @returns {React.ReactElement}
 * */
export const GiftLoading = ({ visible, loadingText }) => {
  if (!visible) {
    return null
  }

  return (
    <div className="gift-loading">
      <div className="gift-loading__section">
        <div className="gift-loading__load">
          <Loading visible icon={LOADING_ICON_BLUE_DARK_BG_WHITE} />
        </div>
        <div>{loadingText}</div>
      </div>
    </div>
  )
}

GiftLoading.propTypes = GiftLoadingPropTypes

export default GiftLoading
